/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Import_In_ProgressInputs */

const en_error_import_in_progress = /** @type {(inputs: Error_Import_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An import of these attributes is still running. Wait for it to end.`)
};

/**
* | output |
* | --- |
* | "An import of these attributes is still running. Wait for it to end." |
*
* @param {Error_Import_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_import_in_progress = /** @type {((inputs?: Error_Import_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Import_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_import_in_progress(inputs)
});